export enum EierBrukerAnnetEnum {
  EIER = "Eier",
  BRUKER = "Bruker",
  ANNET = "Annet",
}

export enum TypeAnleggEnum {
  NYANLEGG = "Nyanlegg",
  UTVIDELSE = "Utvidelse",
  EIER = "Eier",
}

export enum ForenkletEllerDetaljertEnum {
  FORENKLET = "Forenklet",
  DETALJERT = "Detaljert",
}
